import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  Modal,
  ControlLabel
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { getExternalVoucher } from "../../../redux/actions/dealActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import moment from "moment";

const history = createHashHistory();
let isLoading = "false";
class LoadVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      limit: 25,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Voucher"],
      links:["home", ""],
      show: false,
      voucher: '',
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.handlePageChange();
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    if(this.props.match.params.dealID){
      isLoading = "true"
      let dealID= this.props.match.params.dealID;
      this.props.getExternalVoucher({dealID: dealID, page: page, limit: this.state.limit});
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.voucherList !== nextProps.voucherList) {
      if (nextProps.voucherList) {
        isLoading = "false";
        const setPageCount =
          nextProps.voucherList.total / nextProps.voucherList.per_page;
        this.setState({
          voucher: nextProps.voucherList.data,
          totalRecords: nextProps.voucherList.total,
          perPage: nextProps.voucherList.per_page,
          pageCount: setPageCount
        });
      }
    }
    
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }


  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    

    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Uplaoded Voucher Detail</header>

            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="clearfix" />
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Voucher Number</th>
                      <th>Create At</th>
                      <th>Assign To</th>
                      <th>Assign At</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(this.state.voucher) ?
                      this.state.voucher.map((data, index) => 
                      <tr key={data.external_voucher_number + index}>
                        <td>{data.external_voucher_number}</td>
                        <td>{(data.created_at) ? moment(data.create_at).format('MM-DD-YYYY HH:mm:ss') : ''}</td>
                        <td>{data.assigned_to}</td>
                        <td>{(data.assigned_at) ? moment(data.assigned_at).format('MM-DD-YYYY HH:mm:ss') : ''}</td>
                        <td className={(data.assigned == 'notAssigned') ? 'text-success' : 'text-danger'}>{(data.assigned == 'notAssigned') ? 'Not Assigned' : 'Assigned'}</td>
                      </tr>
                      )
                      :
                      <tr>
                        <td colSpan="5">Data Not Available</td>
                      </tr>
                    }
                  </tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={pageCount}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoadVoucher.propTypes = {
  getExternalVoucher: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  error: state.dealReducer.error,
  voucherList: state.dealReducer.getVoucher,
});

export default connect(mapStateToProps, {
  clearAlert,
  getExternalVoucher
})(LoadVoucher);



// WEBPACK FOOTER //
// ./src/app/views/admin/deal/LoadVoucher.js